import React, { Component } from 'react'
import { getLfvMasterPlans, validateFvDomain, getToken } from '../../../lib'
import './SubscriptionCheckoutForm.css';
import StripePaymentForm from './StripePaymentForm';
import PaymentConfirmation from './PaymentConfirmation';
import ThankYouPaid from './ThankYouPaid';
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { fetchPlanDetails } from '../../../components/PlanDetails/actions'
import { loadAffiliateScript } from '../../../lib';

class SubscriptionCheckoutForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      accounts_allowed: 1,
      rooms_allowed: 1,
      domain_name: '',
      errorMessage: '',
      total_price: '',
      initial_price: '',
      plan_price: '',
      currentStep: 1,
      stripeToken: '',
      domainNameErrors: '',
      accountsAllowedErr: false,
      roomsAllowed:false,
      domainNameErr:false,
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleDomainChange = this.handleDomainChange.bind(this)
    this.handleConfirmSubmit = this.handleConfirmSubmit.bind(this)
    this.stripeTokenHandler = this.stripeTokenHandler.bind(this)

    this._next = this._next.bind(this)
    this._prev = this._prev.bind(this)
  }

  _next() {
    let currentStep = this.state.currentStep
    currentStep = currentStep >= 2? 2: currentStep + 1
    this.setState({
      currentStep: currentStep
    })

    if (currentStep == 2) {
      loadAffiliateScript();
    }
  }

  _prev() {
    let currentStep = this.state.currentStep
    currentStep = currentStep <= 1? 1: currentStep - 1
    this.setState({
      currentStep: currentStep
    })
  }

  async componentDidMount() {
    const token = getToken()
    this.props.fetchPlanDetails(token);
    const res = await getLfvMasterPlans();
    if (res.status && res.status === 'success') {
      let initial_price = res.data.plans.filter(plan => plan && plan.name === 'initial_price')[0].price
      let plan_price = res.data.plans.filter(plan => plan && plan.name === 'plan_price')[0].price
      this.setState({
        plan_price: plan_price,
        initial_price: initial_price,
        total_price: (5 + (this.state.accounts_allowed * this.state.rooms_allowed - 1)) * plan_price
      })
    }
  }

  handleChange = (e, purpose) => {
    let total_price = this.state.total_price;
    if (purpose === 'accounts_allowed') {
      this.setState({accounts_allowed: e.target.value})
      if(e.target.value.length == 0)
        this.setState({accountsAllowedErr:true})
      else{
        this.setState({accountsAllowedErr:false})
        total_price = (5 + (e.target.value * this.state.rooms_allowed - 1)) * this.state.plan_price;
      }
    } else if (purpose === 'rooms_allowed') {
      this.setState({rooms_allowed: e.target.value})
      if(e.target.value.length == 0)
        this.setState({roomsAllowedErr:true})
      else{
        this.setState({roomsAllowedErr:false})
        total_price = (5 + (this.state.accounts_allowed * e.target.value - 1)) * this.state.plan_price;
      }
    }
    this.setState({total_price})
  }

  handleDomainChange = (e) => {
    let errors = '';
    if (!e.target.value || e.target.value.length === 0 || e.target.value.length < 3) errors = <FormattedMessage id="CreateDomainLabel.minLettersDomain"/>
    if (!e.target.value.match(/^[a-z0-9-]*$/)) errors = <FormattedMessage id="CreateDomainLabel.invalidDomain"/>
    if (e.target.value && e.target.value.length > 39) errors = <FormattedMessage id="CreateDomainLabel.maxLettersDomain"/>
    this.setState({domainNameErrors: errors})

    if (e.target.value.length > 0 && e.target.value.match(/^[a-z0-9-]*$/)) {
      validateFvDomain(e.target.value, this);
    }
    this.setState({domain_name: e.target.value})
  }

  stripeTokenHandler = async (stripeResponse) => {
    if (stripeResponse.error){
      this.setState({errorMessage: stripeResponse.error.message});
    } else {
      this._next();
      this.setState({stripeToken: stripeResponse.token.id});
    }
  }

  handleConfirmSubmit = (evt) => {
    evt.preventDefault();
    const { accounts_allowed, rooms_allowed, domain_name, stripeToken } = this.state;
    const payload = {
      accounts_allowed: accounts_allowed,
      rooms_allowed: rooms_allowed,
      domain_name: domain_name,
      stripeToken: stripeToken,
      new_plan_name: 'premium',
      initial_price: this.props.campaign ? 0 : this.state.initial_price,
      userId: this.props.userId,
      total_price: this.state.total_price
    }
    this.props.subscriptionCreate(payload);
  }

  render() {
    return (
      <div className="CardDemo">
          <div className="checkbox-frame">
            {this.props.paidUpgrade ?
              <ThankYouPaid
                closeModal={this.props.closeModal}
              />
            :
              <div>
                <StripePaymentForm
                  errorMessage={this.state.errorMessage}
                  accounts_allowed={this.state.accounts_allowed}
                  rooms_allowed={this.state.rooms_allowed}
                  domain_name={this.state.domain_name}
                  total_price={this.state.total_price}
                  initial_price={this.state.initial_price}
                  plan_price={this.state.plan_price}
                  currentStep={this.state.currentStep}
                  handleChange={this.handleChange}
                  handleDomainChange={this.handleDomainChange}
                  stripeTokenHandler={this.stripeTokenHandler}
                  closeModal={this.props.closeModal}
                  domainNameErrors={this.state.domainNameErrors}
                  campaign={this.props.campaign}
                  accountsAllowedErr={this.state.accountsAllowedErr}
                  roomsAllowedErr={this.state.roomsAllowedErr}
                  domainNameErr={this.state.domainNameErr}
                />

                <PaymentConfirmation
                  accounts_allowed={this.state.accounts_allowed}
                  rooms_allowed={this.state.rooms_allowed}
                  domain_name={this.state.domain_name}
                  total_price={this.state.total_price}
                  initial_price={this.state.initial_price}
                  plan_price={this.state.plan_price}
                  currentStep={this.state.currentStep}
                  _prev={this._prev}
                  handleConfirmSubmit={this.handleConfirmSubmit}
                  campaign={this.props.campaign}
                />
              </div>
            }
          </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    campaign: state.planDetails.campaign
  }
}
const mapDispatchToProps = dispatch => ({
  fetchPlanDetails: (token) => dispatch(fetchPlanDetails(token))
})
export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionCheckoutForm)



// WEBPACK FOOTER //
// src/routes/ManagePlans/Plans/SubscriptionCheckoutForm.js